import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { toast } from 'react-toastify';
import './Footer.css';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post('/newsletter/subscribe', { email });
      toast.success('Subscribed! Check your inbox.');
      setEmail('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Subscription failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo">🧬 PeptideLab<strong>Pro</strong></div>
            <p>Premium research-grade peptides with verified third-party purity testing. For research purposes only.</p>
            <div className="footer__social">
              <a href="#" aria-label="Twitter">𝕏</a>
              <a href="#" aria-label="Facebook">f</a>
              <a href="#" aria-label="Instagram">📷</a>
              <a href="#" aria-label="YouTube">▶</a>
            </div>
          </div>

          {/* Shop */}
          <div className="footer__col">
            <h4>Shop</h4>
            <Link to="/shop">All Products</Link>
            <Link to="/shop?category=peptides">Peptides</Link>
            <Link to="/shop?category=growth">Growth Factors</Link>
            <Link to="/shop?category=weight">Weight Management</Link>
            <Link to="/shop?category=recovery">Recovery</Link>
            <Link to="/shop?category=bundles">Bundles</Link>
          </div>

          {/* Info */}
          <div className="footer__col">
            <h4>Information</h4>
            <Link to="/about">About Us</Link>
            <Link to="/blog">Research Blog</Link>
            <Link to="/certificates">Testing &amp; Certificates</Link>
            <Link to="/calculator">Peptide Calculator</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/contact">Contact Us</Link>
          </div>

          {/* Newsletter */}
          <div className="footer__col">
            <h4>Research Updates</h4>
            <p className="footer__newsletter-desc">Get the latest research news and exclusive offers.</p>
            <form onSubmit={handleSubscribe} className="footer__newsletter">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="form-input"
                required
              />
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? '…' : 'Subscribe'}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="footer__disclaimer">
        <div className="container">
          <p>⚠️ <strong>Research Use Only:</strong> All products sold by PeptideLabPro are intended for laboratory research purposes only. These products are not intended for human consumption, self-administration, or veterinary use. By purchasing, you confirm you are a qualified researcher aged 18+ and will use these compounds in a laboratory setting in compliance with all applicable laws and regulations.</p>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer__bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} PeptideLabPro. All rights reserved.</span>
          <div className="footer__legal">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Shipping Policy</a>
            <a href="#">Refund Policy</a>
          </div>
          <div className="footer__payments">₿ Bitcoin · Ξ Ethereum · USDC · Litecoin · BNB</div>
        </div>
      </div>
    </footer>
  );
}
